export default [
    {
        path: '/company/:companyId/module/:moduleId',
        component: () => import('@/views/page/company/Home.vue'),
        name: 'Company',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/dashboard',
        component: () => import('@/views/page/company/Dashboard.vue'),
        name: 'companyDashboard',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId',
        component: () => import('@/views/page/company/Submenu.vue'),
        name: 'CompanySubmenu',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/company-preference/:pageId',
        component: () => import('@/views/page/company/company-preference/List.vue'),
        name: 'company-preference',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/message-log/:pageId',
        component: () => import('@/views/page/company/message-log/List.vue'),
        name: 'message-log',
        meta: {
            requiresAuth: true
        }
    },

]